import Vue from 'vue'

import router from '@/router'
import store from '@/store'
import VueRavello from './plugin'

Vue.use(VueRavello, {
	router,
	store,
})
